/**
 * Extractors for `getPlantUtilityDetail` — utility node + inbound
 * REQUIRES_UTILITY consumers with standard edge shape, plus Factory
 * breadcrumb Site/Line from HAS_UTILITY ownership.
 */

import { extractNode } from '../graph-row'
import { compareByNameThenId } from '../sort'
import type {
  CypherReadResult,
  PlantEquipment,
  PlantLine,
  PlantSite,
  PlantUtilityConsumer,
  PlantUtilityDetail,
  PlantUtilityDetailNode
} from '../types'
import { extractPlantEdges } from './edges'

function extractConsumers(value: unknown): PlantUtilityConsumer[] {
  if (!Array.isArray(value)) return []
  const rows: PlantUtilityConsumer[] = []
  for (const item of value) {
    if (!item || typeof item !== 'object') continue
    const row = item as Record<string, unknown>
    const equipment = extractNode<PlantEquipment>(row['equipment'])
    if (!equipment) continue
    const edge = extractPlantEdges([row['edge']])[0]
    if (!edge) continue
    rows.push({ equipment, edge })
  }
  return rows.sort((a, b) => compareByNameThenId(a.equipment, b.equipment))
}

export function mapPlantUtilityDetail(
  raw: CypherReadResult,
  utilityId: string
): PlantUtilityDetail {
  const row = raw.results[0] ?? {}
  const utility =
    extractNode<PlantUtilityDetailNode>(row['u']) ??
    ({
      id: utilityId,
      _id: utilityId,
      name: 'Unknown utility'
    } satisfies PlantUtilityDetailNode)

  return {
    utility,
    consumers: extractConsumers(row['consumers']),
    site: extractNode<PlantSite>(row['site']),
    line: extractNode<PlantLine>(row['line']),
    isStray: row['isStray'] === true
  }
}
